export default __webpack_public_path__ + "static/media/upEC.d883686f.png";